import { AxiosResponse } from "axios";
import { client } from "../../shared/services/client";
import { GetDocumentRequestModel } from "../model/GetDocumentRequestModel";
import { GetDocumentResponseDto } from "../model/GetDocumentResponseDto";
import { RefiTodoListDto } from "../model/RefiiTodoListDto";
import { RefiDocument } from "../model/RefiDocument";
import { DocQueueDocumentListResponseDto } from "../model/DocQueueDocumentListResponseDto";
import { DocQueueFolderListResponseDto } from "../model/DocQueueFolderListResponseDto";
import { GetDocumentListQuery } from "../model/GetDocumentListQuery";
import { DocQueueGroupListResponseDto } from "../model/DocQueueGroupListResponseDto";
import { GetFolderListByGroupIdQuery } from "../model/GetFolderListByGroupIdQuery";
import { RefiApprovalDropdownDto } from "../model/RefiApprovalDropdownDto";
import { MoveDocumentsFolderDto } from "../model/MoveDocumentsFolderDto";
import { MoveDocumentResponseDto } from "../model/MoveDocumentResponseDto";
import { DeleteDocumentListRequest } from "../model/DeleteDocumentListRequest";
import { DeleteAdminDocumentListRequest } from "../model/DeleteAdminDocumentListRequest";
import { DeleteAdminFolderResponseDto } from "../model/AdminDocument/DeleteAdminFolderResponseDto";
import { DeleteDocumentsResponseDto } from "../model/DeleteDocumentsResponseDto";
import { GetDocumentResult } from "../model/GetDocumentResult";
import { GroupListDocCountResponseDto } from "../model/GroupListDocCountResponseDto";
import { FolderListDocCountResponseDto } from "../model/FolderListDocCountResponseDto";
import { CommonDataDto } from "../../customer/model/CommonDataDto";
import UserSetupModel from "../../Admin/model/userSetupModel";
import { DocIndexingDocumentTypeListResponseDto } from "../model/DocIndexingDocumentTypeListResponseDto";
import { GetDocumentTypeListQuery } from "../model/GetDocumentTypeListQuery";
import { GetDocumentInfoOnSearchResponseDto } from "../model/GetDocumentInfoOnSearchResponseDto";
import { GetDocumentInfoOnSearchRequestDto } from "../model/GetDocumentInfoOnSearchRequestDto";
import { DocumentStatusResponseDto } from "../model/DocumentStatusResponseDto";
import { GetCustomerDataQuery } from "../model/GetCustomerDataQuery";
import { CustomerDataResponseDto } from "../model/CustomerDataResponseDto";
import { DocumentOnHoldStatusResponseDto } from "../model/DocumentOnHoldStatusResponseDto";
import { DocumentFileDetailsResponseDto } from "../model/DocumentFileDetailsResponseDto";
import DocHistoryModel from "../model/DocHistoryModel";
import { UsersListByGroupIdResponseDto } from "../model/UsersListByGroupIdResponseDto";
import {UploadCustomerDocumentResponse} from "../model/UploadCustomerDocumentResponse";
import { DocumentCloseResponseDto } from "../model/DocumentCloseResponseDto";
import { RedirectDocumentCommand } from "../model/RedirectDocumentCommand";
import { RedirectDocumentResponseDto } from "../model/RedirectDocumentResponseDto";
import { UserListWithDeleteAccessResponseDto } from "../model/UserListWithDeleteAccessResponseDto";
import { DeleteDocumentRequest } from "../model/DeleteDocumentRequest";
import { DeleteDocumentResponseDto } from "../model/DeleteDocumentResponseDto";
import { RestoreDocumentResponseDto } from "../model/RestoreDocumentResponseDto";
import { DocCategoryDto } from "../model/AdminDocument/DocCategoryDto";
import { GeneralDocFolderContentsDto } from "../model/AdminDocument/GeneralDocFolderContentsDto";
import { DocFolderDto } from "../model/AdminDocument/DocFolderDto";
import { AdminDocumentSearchResponseDto } from "../model/AdminDocument/AdminDocumentSearchDto";
import { LockDocumentsResponseDto } from "../model/LockDocumentsResponseDto";
import { NoteDto } from "../model/AdminDocument/NoteDto";

export const addNote = async (entityId: string, notes: string): Promise<NoteDto> => {
    client.setBaseURLForService("documateapp");
    const res: AxiosResponse<NoteDto> = await client.post("/api/GeneralDocStorage/AddNote", {
        EntityId: entityId,
        Notes: notes
    });
    return res.data;
}

export const getNotesByEntityId = async (entityId: string): Promise<NoteDto[]> => {
    client.setBaseURLForService("documateapp");
    const res: AxiosResponse<NoteDto[]> = await client.get("/api/GeneralDocStorage/GetNotesByEntityId", {
        params: { EntityId: entityId }
    });
    return res.data ?? [];
}

export const getListOfGroup = async (fetchMailRoom: boolean): Promise<DocQueueGroupListResponseDto[]> => {
    client.setBaseURLForService("documate");
    const res: AxiosResponse<DocQueueGroupListResponseDto[]> = await client.get("/api/DocQueue/GetListOfGroups?fetchMailRoom=" + fetchMailRoom);
    return res.data;
}

export const getListOfFolderByGroupId = async (getFolderListByGroupIdQuery: GetFolderListByGroupIdQuery): Promise<DocQueueFolderListResponseDto[]> => {
    client.setBaseURLForService("documate");
    const config = { params: getFolderListByGroupIdQuery };
    const res: AxiosResponse<DocQueueFolderListResponseDto[]> = await client.get("/api/DocQueue/GetListOfFoldersByGroupId", config);
    return res.data;
}

export const getListOfFolder = async (): Promise<DocQueueFolderListResponseDto[]> => {
    client.setBaseURLForService("documate");
    const res: AxiosResponse<DocQueueFolderListResponseDto[]> = await client.get("/api/DocQueue/GetListOfFolders");
    return res.data;
}

export const getUnAssignedDocument = async (getUnAssignedDocumentRequestModel: GetDocumentListQuery): Promise<DocQueueDocumentListResponseDto[]> => {
    client.setBaseURLForService("documate");
    const config = { params: getUnAssignedDocumentRequestModel };
    const res: AxiosResponse<DocQueueDocumentListResponseDto[]> = await client.get("/api/DocQueue/GetListOfDocument", config);
    return res.data;
}

export const moveDocumentAPI = async (fromDocQueueId: string, toDocQueueId: string, documents: string[]) => {
    client.setBaseURLForService("documate");
    const moveDocumentsFolderCommand: MoveDocumentsFolderDto = {
        fromDocQueueId: fromDocQueueId,
        toDocQueueId: toDocQueueId,
        documents: documents
    }

    const res: AxiosResponse<MoveDocumentResponseDto> = await client.post("/api/DocQueue/MoveDocumentsFolder", moveDocumentsFolderCommand);
    return res.data;
}

export const deleteDocumentAPI = async (listOfDocument: string[]): Promise<DeleteDocumentsResponseDto> => {
    client.setBaseURLForService("documate");
    const deleteDocumentRequestModel: DeleteDocumentListRequest = {
        documents: listOfDocument
    }
    const res: AxiosResponse<DeleteDocumentsResponseDto> = await client.post("/api/DocQueue/DeleteListOfDocument", deleteDocumentRequestModel);
    return res.data;
}

// Soft deletes admin documents: the documents move to the GeneralDocStorage.AdminDocRecycleBin
// Returns the ids that were actually deleted.
export const deleteAdminDocumentList = async (appId: number, listOfDocument: string[]): Promise<string[]> => {
    client.setBaseURLForService("documateapp");
    const deleteAdminDocumentRequestModel: DeleteAdminDocumentListRequest = {
        appId: appId,
        documents: listOfDocument
    }
    const res: AxiosResponse<string[]> = await client.post("/api/GeneralDocStorage/DeleteListOfAdminDocument", deleteAdminDocumentRequestModel);
    return res.data ?? [];
}
export const UpdatePolicyNumberOfDocument = async (request: {
    oldPolicyNumber: string,
    newPolicyNumber: string,
    custNumber?: string,
    polEffDate?: string,
    polExpDate?: string
}): Promise<any> => {
    client.setBaseURLForService("documateapp");
    const res: AxiosResponse<any> = await client.post("/api/AppDocStorage/UpdatePolicyNumberOfDocument", request);
    return res.data;
};

export const getDocument = async (Id: string, firstPageOnly?: boolean, convertToPDF: boolean = true): Promise<GetDocumentResult> => {
    client.setBaseURLForService("documateapp");
    var blob, filename;
     
    let url = "api/AppDocStorage/GetDocument?FileId=" + Id;
    if (firstPageOnly) {
        url += "&FirstPageOnly=true";
    }
    if (!convertToPDF) {
        url += "&ConvertToPDF=false";
    }

    const res: AxiosResponse<Blob> = await client.get(url, {
        responseType: 'blob',  // This tells Axios to treat the response as a Blob
    });

    filename = res.headers['filename'];
    const contentType = res.headers['contenttype'];
    blob = res.data;  
    
    const response = {
        blob: blob,
        filename: filename,
        contentType: contentType
    };
        
    return response;
}

export const getRefiDocument = async (docId: string): Promise<any> => {
    client.setBaseURLForService("documateapp");
    const res: AxiosResponse<Blob> = await client.get(`/api/DocumateRefiApproval/RefiDocument?RefiRequestId=${docId}`, {
        responseType: 'blob',  // This tells Axios to treat the response as a Blob
    });
    return res;
}

export const fetchRefiTodoList = async () => {
    client.setBaseURLForService("documateapp");
    const res: AxiosResponse<RefiTodoListDto[]> = await client.get<RefiTodoListDto[]>("/api/DocumateRefiApproval/RefiList");
    return res.data;
}

export const getRefiDocumentFields = async (id: string) => {
    client.setBaseURLForService("documateapp");
    const res: AxiosResponse<RefiDocument> = await client.get<RefiDocument>(`/api/DocumateRefiApproval/RefiDocumentFields?RefiRequestId=${id}`);
    return res.data;
}

export const getListOfVestingDropdown = async (): Promise<RefiApprovalDropdownDto[]> => {
    client.setBaseURLForService("documateapp");
    const res: AxiosResponse<RefiApprovalDropdownDto[]> = await client.get("api/DocumateRefiApproval/VestingDropdowns");
    return res.data;
}

export const updateRefiDocumentStatus = async (id: string, status: string): Promise<any> => {
    client.setBaseURLForService("documateapp");
    const res: AxiosResponse = await client.post(`/api/DocumateRefiApproval/UpdateRefiDocumentStatus?RefiRequestId=${id}&RequestStatus=${status}`);
    return res;
}

export const rejectRefiDocument = async (refiDocument: RefiDocument): Promise<any> => {
    client.setBaseURLForService("documateapp");
    const res: AxiosResponse = await client.post(`/api/DocumateRefiApproval/RejectRefiDocument`, refiDocument);
    return res;
}

export const getListOfGroupDocCountToDoList = async (): Promise<GroupListDocCountResponseDto[]> => {
    client.setBaseURLForService("documate");
    const res: AxiosResponse<GroupListDocCountResponseDto[]> = await client.get("/api/DocQueue/GetListOfGroupsWithDocumentCount");
    return res.data;
}

export const getListOfFolderDocCountToDoList = async (groupId: string): Promise<FolderListDocCountResponseDto[]> => {
    client.setBaseURLForService("documate");
    const res: AxiosResponse<FolderListDocCountResponseDto[]> = await client.get(`/api/DocQueue/GetListOfFolderWithDocumentCountByGroupId?groupId=${groupId}`);
    return res.data;
}

export const approveRefiDocument = async (refiDocument: RefiDocument): Promise<any> => {
    client.setBaseURLForService("documateapp");
    const res: AxiosResponse = await client.post(`/api/DocumateRefiApproval/ApproveRefiDocument`, refiDocument);
    return res;
}

export const getUsersRecycleBin = async (): Promise<UserListWithDeleteAccessResponseDto[]> => {
    client.setBaseURLForService("documate")
    const res: AxiosResponse<UserListWithDeleteAccessResponseDto[]> = await client.get<UserListWithDeleteAccessResponseDto[]>("api/DocQueue/ListOfUsersWithDeleteAccess");
    return res.data.sort((a) => {
        const getLabel = (obj: any) => (obj.displayName ?? '').trim();
        return getLabel(a).localeCompare(getLabel(a));
    });
}

export const getUsersToDoList = async (groupIdList: string[]): Promise<UsersListByGroupIdResponseDto[]> => {
    client.setBaseURLForService("documate");
    const params = new URLSearchParams();
    groupIdList.forEach(item => params.append('groupIdList', item));
    const res: AxiosResponse<UsersListByGroupIdResponseDto[]> = await client.get(`/api/DocQueue/GetUserListByGroupId?${params.toString()}`);
    return res.data.sort((a, b) => {
        const getLabel = (obj: any) => (obj.displayName ?? '').trim();
        return getLabel(a).localeCompare(getLabel(b));
    });
}

export const getDocumentTypeList = async (getDocumentTypeListRequestModel: GetDocumentTypeListQuery): Promise<DocIndexingDocumentTypeListResponseDto[]> => {
    client.setBaseURLForService("documateapp");
    const config = { params: getDocumentTypeListRequestModel };
    const res: AxiosResponse<DocIndexingDocumentTypeListResponseDto[]> = await client.get("/api/AppDocStorage/GetDocumentTypeList", config);
    return res.data;
}


export const searchDocToDoList = async (groupId: string[], folderIds: string[], users: string[], isDeleted: boolean): Promise<GetDocumentInfoOnSearchResponseDto[]> => {
    client.setBaseURLForService("documate");
    const searchDocRequest = {
        groupId: groupId,
        folderIds: folderIds,
        userIds: users,
        isDeleted: isDeleted
    }    
    const res: AxiosResponse<GetDocumentInfoOnSearchResponseDto[]> = await client.post("/api/DocQueue/SearchDocumentOnToDoList", searchDocRequest);
    return res.data;
}

export const updateDocStatusToDoList = async (id: string, documentStatus: number, documentUserId: string): Promise<DocumentStatusResponseDto> => {
    client.setBaseURLForService("documate");
    const updateDocStatusRequest = {
        Id: id,
        documentStatus: documentStatus,
        documentUserId: documentUserId
    }
    const res: AxiosResponse<DocumentStatusResponseDto> = await client.post("/api/DocQueue/UpdateDocumentStatus", updateDocStatusRequest);
    return res.data;
}

export const getCustomerData = async (getCustomerDataQueryModel: GetCustomerDataQuery): Promise<CustomerDataResponseDto[]> => {
    client.setBaseURLForService("documateapp");
    const config = { params: getCustomerDataQueryModel };
    const res: AxiosResponse<CustomerDataResponseDto[]> = await client.get("/api/DocumentIndexingProcessing/GetCustomerDataByRefNum", config);
    return res.data;
}

export const updateDocumentStatusForOnHold = async (id: string): Promise<DocumentOnHoldStatusResponseDto> => {
    client.setBaseURLForService("documate");
    const updateOnHoldDocStatusRequest = {
        id: id
    }
    const res: AxiosResponse<DocumentOnHoldStatusResponseDto> = await client.post("/api/DocQueue/UpdateDocumentOnHoldStatus", updateOnHoldDocStatusRequest);
    return res.data;
}

export const getDocumentFileDetailsById = async (id: string): Promise<DocumentFileDetailsResponseDto> => {
    client.setBaseURLForService("documate");

    const res: AxiosResponse<DocumentFileDetailsResponseDto> = await client.get(`/api/DocQueue/GetDocumentFileDetailsById?id=${id}`);
    return res.data;
}

export const IndexDocument = async (id: string, toAppId: number, DocumentTypeId: string ,indexkey1: string, indexKey2: string, attributes: string): Promise<any> => {
    client.setBaseURLForService("documateapp");
    const indexDocumentRequest = {
        queuedDocId: id,
        toAppId: toAppId,
        DocumentTypeId: DocumentTypeId,
        indexKey1: indexkey1,
        indexKey2: indexKey2,
        attributes: attributes

    }
    const res: AxiosResponse<any> = await client.post("/api/AppDocStorage/IndexDocument", indexDocumentRequest);
    return res.data;
}

export const AddDocNotes = async (Id: string, comment: string): Promise<DocHistoryModel[]> => {
    client.setBaseURLForService("documate");
    const addDocNotesRequest = {
        Id: Id,
        comment: comment
    }
    const res: AxiosResponse<any> = await client.post("/api/DocQueue/AddDocNotes", addDocNotesRequest);
    return res.data;
}

export const GetDocHistory = async (entityId: string): Promise<DocHistoryModel[]> => {
    client.setBaseURLForService("documate");
    const res: AxiosResponse<any> = await client.get<DocHistoryModel[]>(`/api/DocQueue/GetDocHistory?entityId=${entityId}`);
    console.log(res.data)
    return res.data;
}

export const UploadCustomerDocument = async (
    file: File,
    uploadDocRequestPayload: {
        appId: number,
        fileName: string,
        contentType: string,
        documentTypeId: string,
        indexKey1: string,
        indexKey2: string,
        attributes: string,
        userId: string,
        queuePath?: string
    }
): Promise<UploadCustomerDocumentResponse> => {
    client.setBaseURLForService("documateapp");
    const params = new URLSearchParams({
        appId: uploadDocRequestPayload.appId.toString(),
        fileName: uploadDocRequestPayload.fileName,
        contentType: uploadDocRequestPayload.contentType,
        documentTypeId: uploadDocRequestPayload.documentTypeId,
        indexKey1: uploadDocRequestPayload.indexKey1,
        indexKey2: uploadDocRequestPayload.indexKey2,
        attributes: uploadDocRequestPayload.attributes,
        userId: uploadDocRequestPayload.userId
    });
    if (uploadDocRequestPayload.queuePath) {
        params.append('queuePath', uploadDocRequestPayload.queuePath);
    }
    const url = `/api/AppDocStorage/UploadDocument?${params.toString()}`;
    const res: AxiosResponse<UploadCustomerDocumentResponse> = await client.post(
        url,
        file,
        {
            headers: {
                "Content-Type": file.type
            }
        }
    );
    return res.data;
};

export const CloseDocument = async (Id: string): Promise<DocumentCloseResponseDto> => {
    client.setBaseURLForService("documate");
    const closeDocumentRequest = {
        Id: Id
    }
    const res: AxiosResponse<DocumentCloseResponseDto> = await client.post("/api/DocQueue/CloseDocument", closeDocumentRequest);
    return res.data;
}

export const RedirectDocuments = async (redirectDocumentCommand: RedirectDocumentCommand): Promise<RedirectDocumentResponseDto> => {
    client.setBaseURLForService("documate");
    const res: AxiosResponse<RedirectDocumentResponseDto> = await client.post("/api/DocQueue/RedirectDocument", redirectDocumentCommand);
    return res.data;
}

export const deleteDocumentCustomer = async (docId: string): Promise<DeleteDocumentResponseDto> => {
    client.setBaseURLForService("documate");
    const deleteDocumentRequestModel: DeleteDocumentRequest = {
        documentId : docId
    }
    const res: AxiosResponse<DeleteDocumentResponseDto> = await client.post("/api/DocQueue/DeleteDocument", deleteDocumentRequestModel);
    return res.data;
}

export const restoreDocumentAPI = async (docQueueId: string): Promise<RestoreDocumentResponseDto> => {
    client.setBaseURLForService("documate");
    const restoreDocumentRequestModel = {
        docQueueId : docQueueId
    }
    const res: AxiosResponse<RestoreDocumentResponseDto> = await client.post("/api/DocQueue/RestoreDocument", restoreDocumentRequestModel);
    return res.data;
}

export const fetchDocCategory = async (): Promise<DocCategoryDto[]> => {
    client.setBaseURLForService("documateapp");
    const res: AxiosResponse<DocCategoryDto[]> = await client.get("/api/GeneralDocStorage/FetchDocCategory");
    return res.data;
}

export const fetchDocFolder = async (appId: number, categoryId?: string, parentFolderId?: string): Promise<GeneralDocFolderContentsDto> => {
    client.setBaseURLForService("documateapp");
    const config = { params: { AppId: appId, CategoryId: categoryId, FolderId: parentFolderId } };    
    const res: AxiosResponse<GeneralDocFolderContentsDto> = await client.get("/api/GeneralDocStorage/FetchDocFolder", config);
    return res.data;
}

export const createDocFolder = async (
    name: string,
    categoryId?: string,
    parentFolderId?: string
): Promise<DocFolderDto> => {
    client.setBaseURLForService("documateapp");
    const createFolderRequest = {
        Name: name,
        CategoryId: categoryId,
        ParentFolderId: parentFolderId
    };
    const res: AxiosResponse<DocFolderDto> = await client.post("/api/GeneralDocStorage/CreateDocFolder", createFolderRequest);
    return res.data;
}

export const renameDocFolder = async (
    folderId: string,
    name: string
): Promise<DocFolderDto> => {
    client.setBaseURLForService("documateapp");
    const renameFolderRequest = {
        FolderId: folderId,
        Name: name
    };
    const res: AxiosResponse<DocFolderDto> = await client.post("/api/GeneralDocStorage/RenameDocFolder", renameFolderRequest);
    return res.data;
}

export const fetchAdminFolderDocumentCount = async (appId: number, folderId: string): Promise<number> => {
    client.setBaseURLForService("documateapp");
    const config = { params: { AppId: appId, FolderId: folderId } };
    const res: AxiosResponse<number> = await client.get("/api/GeneralDocStorage/FetchAdminFolderDocumentCount", config);
    return res.data ?? 0;
}

export const deleteAdminFolder = async (appId: number, folderId: string): Promise<DeleteAdminFolderResponseDto> => {
    client.setBaseURLForService("documateapp");
    const res: AxiosResponse<DeleteAdminFolderResponseDto> = await client.post("/api/GeneralDocStorage/DeleteAdminFolder", { appId, folderId });
    return { deletedFolders: res.data?.deletedFolders ?? [], deletedDocuments: res.data?.deletedDocuments ?? [] };
}

export const adminDocumentSearch = async (searchText: string, onlyFolderSearch: boolean = false): Promise<AdminDocumentSearchResponseDto> => {
    client.setBaseURLForService("documateapp");
    const config = { params: { SearchText: searchText, OnlyFolderSearch: onlyFolderSearch } };
    const res: AxiosResponse<AdminDocumentSearchResponseDto> = await client.get("/api/GeneralDocStorage/AdminDocumentSearch", config);
    return res.data;
}

export const toggleDocumentLock = async (documentId: string, markLock: boolean): Promise<LockDocumentsResponseDto> => {
    client.setBaseURLForService("documate");
    const endpoint = markLock ? "/api/DocQueue/LockDocument" : "/api/DocQueue/UnlockDocument";
    const res: AxiosResponse<LockDocumentsResponseDto> = await client.post(endpoint, { documentId });
    return res.data;
}

export const getMyLockedDocuments = async (): Promise<string[]> => {
    client.setBaseURLForService("documate");
    const res: AxiosResponse<string[]> = await client.get("/api/DocQueue/GetMyLockedDocuments");
    return res.data;
}

export const hardLockDocument = async (documentId: string): Promise<LockDocumentsResponseDto> => {
    client.setBaseURLForService("documate");
    const res: AxiosResponse<LockDocumentsResponseDto> = await client.post("/api/DocQueue/HardLockDocument", { documentId });
    return res.data;
}

export const releaseSoftLockDocuments = async (): Promise<LockDocumentsResponseDto> => {
    client.setBaseURLForService("documate");
    const res: AxiosResponse<LockDocumentsResponseDto> = await client.post("/api/DocQueue/ReleaseAllLocks");
    return res.data;
}